<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <div>&nbsp;</div>
      <ul class="nav" v-if="isMenuDefault">
        <li class="nav-item">
          <router-link :to="{ name: 'PaginaInicial' }" class="nav-link"><i class="fas fa-home"></i> {{$lang.Menu.Items.StartPage}}</router-link>
        </li>
        <li class="nav-item" v-if="!hasRole(roles.USUARIO_EXTERNO)">
          <router-link :to="{ name: 'Associate' }" class="nav-link"><i class="fas fa-users"></i> Associados</router-link>
        </li>
        <li class="nav-item" v-if="hasKanban">
          <router-link :to="{ name: 'CRM' }" class="nav-link"><i class="fas fa-address-card"></i> CRM</router-link>
        </li>
        <li class="nav-item" v-if="hasKanban">
          <router-link :to="{ name: 'Ajuizamento' }" class="nav-link"><i class="fas fa-balance-scale"></i> Ajuizamento</router-link>
        </li>
        <li class="nav-item nav-dropdown" v-if="hasKanban">
          <div class="nav-link nav-dropdown-toggle" @click.prevent="handleClick"><i class="fas fa-file-invoice-dollar"></i> Cobrança</div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="{ name: 'Cobrança' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Gerenciar Cobrança</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'CobrançaUpdates' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Ver Atualizações</router-link>
            </li>
          </ul>
        </li>
        <li id="campanhas" class="nav-item nav-dropdown" v-if="!hasRole(roles.USUARIO_EXTERNO) && (hasRole(roles.ADMINISTRADOR) || hasRole(roles.ACESSO_CAMPANHA))">
          <div class="nav-link nav-dropdown-toggle" @click.prevent="handleClick"><i class="fas fa-bullhorn"></i> Campanha</div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="{ name: 'Campanha' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Gerenciar Campanha</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'RedeSocial' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Rede Social</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'BlackList' }" class="nav-link" exact><i class="fa fa-caret-right"></i> BlackList</router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'Visitas' }" class="nav-link"><i class="fas fa-map-marked-alt"></i> Visitas</router-link>
        </li>
<!--        <li class="nav-item">-->
<!--          <router-link :to="{ name: 'GED' }" class="nav-link"><i class="fas fa-box-open"></i> GED</router-link>-->
<!--        </li>-->

        <li class="nav-item" v-if="hasRole(roles.IMPORTACAO_PLANILHA)">
          <router-link :to="{ name: 'Importacao' }" class="nav-link"><i class="fas fa-file-import"></i> Importação</router-link>
        </li>
        <div v-if="hasAtendimento">
          <li  v-if="hasRole('OPERADOR_ATENDIMENTO_GERAL') || hasRole('OPERADOR_ATENDIMENTO') || hasRole('GESTOR_ATENDIMENTO')" id="atendimento" class="nav-item nav-dropdown"   >
          <div class="nav-link nav-dropdown-toggle" @click.prevent="handleClick"><i class="fas fa-headset"></i> Atendimento</div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="{ name: 'Atendimento' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Conversas</router-link>
            </li>
            <li v-if="hasRole('OPERADOR_ATENDIMENTO')"  class="nav-item">
              <router-link :to="{ name: 'CentralAtendimento' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Central PA</router-link>
            </li>
            <li v-if="hasRole('OPERADOR_ATENDIMENTO_GERAL')" class="nav-item">
              <router-link :to="{ name: 'CentralAtendimentoGeral' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Central Geral</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'HistoricoAtendimento' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Histórico</router-link>
            </li>
            <li class="nav-item" v-if="hasRole('GESTOR_ATENDIMENTO')" >
              <router-link :to="{ name: 'RelatorioAtendimento' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Relatório</router-link>
            </li>
            <li v-if="hasRole('GESTOR_ATENDIMENTO')" class="nav-item">
              <router-link :to="{ name: 'MetricaAtendimento' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Métricas</router-link>
            </li>
          </ul>
        </li>
        </div>
          <!-- <router-link :to="{ name: 'Campanha' }" class="nav-link"><i class="fas fa-bullhorn"></i> Campanha <b-badge variant="primary">Novo</b-badge></router-link> -->
        <li v-if="hasRole(roles.ACESSO_RELATORIOS)" id="campanhas" class="nav-item nav-dropdown">
          <div class="nav-link nav-dropdown-toggle" @click.prevent="handleClick"><i class="fas fa-chart-bar"></i> Relatórios</div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="{ name: 'RelatorioCrm' }" class="nav-link" exact><i class="fa fa-caret-right"></i> CRM</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'RelatorioAjuizamento' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Ajuizamento</router-link>
            </li>
            <li class="nav-item" @click="toggleChild('relatorioFollowUp__container')">
              <div class="nav-link">
                <i class="fa fa-caret-right caret-direction-relatorioFollowUp__container"></i> Follow-Up
              </div>
              <!-- <router-link :to="{ name: 'relatorioVisitas' }" class="nav-link" exact disabled><i class="fa fa-caret-right"></i> CRM</router-link> -->
            </li>
            <div class="relatorioFollowUp__container d-none">
              <li class="nav-item">
                <router-link :to="{ name: 'RelatorioCrmActions' }" class="nav-link deep-item" exact><i class="fa fa-caret-right"></i> Ações CRM</router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{ name: 'RelatorioFollowUp' }" class="nav-link deep-item" exact><i class="fa fa-caret-right"></i> Ocorrências</router-link>
              </li>
            </div>
            <li class="nav-item" @click="toggleChild('relatorioVisitas__container')">
              <div class="nav-link">
                <i class="fa fa-caret-right caret-direction-relatorioVisitas__container"></i> Visitas
              </div>
              <!-- <router-link :to="{ name: 'relatorioVisitas' }" class="nav-link" exact disabled><i class="fa fa-caret-right"></i> CRM</router-link> -->
            </li>
            <div class="relatorioVisitas__container d-none">
              <li class="nav-item ">
                <router-link :to="{ name: 'RelatorioDeslocamento' }" class="nav-link deep-item" exact><i class="fa fa-caret-right"></i> Deslocamento</router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{ name: 'RelatorioDespesas' }" class="nav-link deep-item" exact><i class="fa fa-caret-right"></i> Despesas</router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{ name: 'RelatorioAcompanhamento' }" class="nav-link deep-item" exact><i class="fa fa-caret-right"></i>Acompanhamento</router-link>
              </li>
            </div>
            <li v-if="hasRole(roles.ACESSO_CAMPANHA)" class="nav-item" @click="toggleChild('relatorioCampanha__container')">
              <div class="nav-link">
                <i class="fa fa-caret-right caret-direction-relatorioCampanha__container"></i> Campanha
              </div>
              <!-- <router-link :to="{ name: 'relatorioCampanha' }" class="nav-link" exact disabled><i class="fa fa-caret-right"></i> CRM</router-link> -->
            </li>
            <div class="relatorioCampanha__container d-none">
              <li class="nav-item ">
                <router-link :to="{ name: 'RelatorioCampanha' }" class="nav-link deep-item" exact><i class="fa fa-caret-right"></i> Campanhas</router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{ name: 'ReportEnvioCampanha' }" class="nav-link deep-item" exact><i class="fa fa-caret-right"></i> Envios de Campanha</router-link>
              </li>
            </div>
          </ul>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'Anexos' }" class="nav-link"><i class="fas fa-paste"></i> Repositório de Anexos</router-link>
        </li>
        <li class="nav-item" v-if="!hasRole(roles.USUARIO_EXTERNO)" @click="onShowSidebarSetting">
          <a class="nav-link"><i class="fas fa-cogs"></i> Cadastros</a>
        </li>

        <li class="nav-item" v-for="(item, index) in myLinks" :key="index">
          <a class="nav-link" :href="onGetUrl(item.url)" target="_blank"><i :class="item.icon"></i> {{item.nome}}</a>
        </li>

        <li class="divider"></li>
        <li class="pt-5">&nbsp;</li>
      </ul>
      <SidebarSetting ref="SidebarSetting" v-show="isMenuSetting" @BackMenu="onBackMenu" />
    </nav>
  </div>
</template>
<script>
import Roles from '@/shared/utils/roles.js'
// import PermissionMixin from '@/store/module/permission/mixin'
import { JWTService } from '@/shared/services/jwt'
import AccountMixin from '@/store/module/account/mixin'
import actionForms from '@/shared/mixins/actionsForm.js'
import SidebarSetting from './sidebars/SidebarSettings.vue'
import LinksRepository from '@/shared/http/repositories/configurations/links.js'
import { toast, loading } from '@/shared/utils/UIHelper'
// import Tools from '@/components/tools/Tools.js'
// import { actionTypes as AccountActions } from '@/store/module/account/actions'

export default {
  name: 'sidebarApp',
  mixins: [ AccountMixin, actionForms ],
  data () {
    return {
      tShieldClient: process.env.TShieldClient,
      hasKanban: process.env.hasKanban,
      roles: Roles,
      permissions: null,
      myLinks: [],
      isMenuDefault: true,
      isMenuSetting: false,
      isMenuSettingAtendimento: false,
      hasAtendimento: process.env.hasAtendimento
    }
  },
  components: {
    SidebarSetting
  },
  mounted () {
    /*
    this[AccountActions.GET_LOGGED]()
      .then((response) => {
      })
    */
    this.permissions = JWTService.GetRoles()
    this.onLoadAllLinks()
  },
  methods: {
    onLoad () {
    },
    handleClick (e) {
      // e.preventDefault()
      e.target.parentElement.classList.toggle('open')
      for (let element of e.target.parentElement.parentElement.children) {
        if (element !== e.target.parentElement) {
          if (element.classList.contains('open')) {
            element.classList.toggle('open')
          }
        }
      }
    },
    toggleChild (e) {
      // e.preventDefault()
      document.querySelector('.' + e).classList.toggle('d-none')
      document.querySelector('.caret-direction-' + e).classList.toggle('caret-direction-bottom')
    },
    RemoveMinimizedSidebar: function () {
      document.body.classList.remove('sidebar-minimized')
      window.scrollTo(0, 0)
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          // if (this.permissions[i].role === role) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    },
    onBackMenu () {
      this.RemoveMinimizedSidebar()
      this.isMenuDefault = true
      this.isMenuSetting = false
    },
    onShowSidebarSetting () {
      this.RemoveMinimizedSidebar()
      this.isMenuSetting = true
      this.isMenuDefault = false
    },
    onLoadAllLinks () {
      loading.push()
      LinksRepository.GetAll()
        .then((response) => {
          this.myLinks = response.data.content
          loading.close()
        })
        .catch((err) => {
          if (err.message === 'Unauthorized' || err.message === 'ExpiredToken' || err.message === 'Cannot read properties of undefined (reading \'status\')') {
            toast.error(this.$lang.Common.SessionEnded)
          } else {
            toast.error(this.$lang.Common.MicroserviceUnavailable)
          }
          loading.pop()
        })
    },
    onGetUrl (value) {
      let result = ''
      const url = value
      if (value && value.substring(0, 4) === 'http') {
        result = url
      } else {
        result = 'http://' + url
      }
      return result
    }
  }
}
</script>

<style lang="css">
.nav-link {
  cursor:pointer;
}
.nav-dropdown-toggle:hover, .nav-dropdown:hover{
  right: 50;
}
.caret-direction-bottom {
  transition: transform 0.15s ease-in-out;
  transform: rotate(90deg);
}
.deep-item{
  margin-left: 1rem !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/Sidebar.vue